import React, { useRef, useEffect } from 'react';
import Hls from 'hls.js';
import { useCameraStartMutation, useCameraStopMutation } from '../api';
import styles from './styles.module.css';

interface CameraPlayerProps {
  src: string;
  cameraId: number;
}

const CameraPlayer: React.FC<CameraPlayerProps> = ({ src, cameraId }) => {
  const videoRef = useRef<HTMLVideoElement>(null);
  const hlsRef = useRef<Hls | null>(null);
  const [startCamera, { isLoading: isStarting }] = useCameraStartMutation();
  const [stopCamera] = useCameraStopMutation();

  useEffect(() => {
    let timeoutId: NodeJS.Timeout;

    const initializeStream = async () => {
      try {
        
        await startCamera(cameraId).unwrap();
      

       
        timeoutId = setTimeout(async () => {
       
          const video = videoRef.current;
          if (!video) return;

          if (hlsRef.current) {
            hlsRef.current.destroy();
          }

          if (Hls.isSupported()) {
            const hls = new Hls();
            hlsRef.current = hls;
            hls.loadSource(src);
            hls.attachMedia(video);
            hls.on(Hls.Events.MANIFEST_PARSED, () => {
              video.play().catch(e => console.error('Error playing video:', e));
            });
          } else if (video.canPlayType('application/vnd.apple.mpegurl')) {
            video.src = src;
            video.addEventListener('loadedmetadata', () => {
              video.play().catch(e => console.error('Error playing video:', e));
            });
          }
        }, 2000);
      } catch (error) {
        console.error('Error initializing stream:', error);
      }
    };

    initializeStream();

    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
      if (hlsRef.current) {
        hlsRef.current.destroy();
      }
      stopCamera(cameraId);
    };
  }, [src, cameraId, startCamera, stopCamera]);

  return (
    <div className={styles.playerContainer}>
      {isStarting && <div className={styles.loading}>Загрузка камеры...</div>}
      <video
        ref={videoRef}
        className={styles.videoPlayer}
        controls
        playsInline
      />
    </div>
  );
};

export default CameraPlayer;
